import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';

export function G_VIEW_generation_price_determining() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  /*
   * EVENTS
   */

  /*
   * HTML
   */
  return (
    <div className="flex-center size-full border border-component-border rounded-lg">
      <span className="text-bar-foreground text-sm">{t(i18n_page_generation.sidebar_user_input.views.generation_price_determining.title)}</span>
    </div>
  );
}
